<template>
  <section>
    <div class='mock'>
      <div class='main'>
        <div class="loading">{ 404 }</div>
        <div>您访问的页面不存在</div>
        <div class="back" @click="goback"> 请返回</div>
      </div>
    </div>
  </section>
</template>

<script>
    export default {
        name: 'page404',
        methods:{
          goback(){
            window.history.back()
          }
        }
    }
</script>

<style scoped>
  section{
    width:100%
  }
  .mock{
  }
  .main{
    color:#5cb85c;
    text-align:center;
  }
  .main div{
    margin:2rem 0;
  }
  .loading{
    font-size: 1.2rem;
    color:red;
  }
</style>



// WEBPACK FOOTER //
// src/components/page404.vue